import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
//Material-UI
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Skeleton from '@material-ui/lab/Skeleton';
import Link from '@material-ui/core/Link';
import Carousel from './Carousel';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

const useStyles = makeStyles(theme => {
   const elevations = {};
   theme.shadows.forEach((shadow, index) => {
      elevations[`elevation${index}`] = {
         boxShadow: shadow
      };
   });
   return {
      root: {
         minHeight: '200px',
         padding: theme.spacing(2),
         textAlign: 'center',
         color: theme.palette.text.secondary,
      },
      container: {
         backgroundColor: theme.palette.background.paper,
         color: theme.palette.text.primary,
         transition: theme.transitions.create('box-shadow'),
         border: `1px solid ${theme.palette.divider}`,
         borderRadius: theme.shape.borderRadius,
         width: '100%',
         height: '100%'
      },
      img: {
         maxHeight: 118,
         maxWidth: 210
      },
      content: {
         height: '100%'
      },
      ...elevations
   };
});

export default function Producto(props) {
   const classes = useStyles();
   const { loading = false, data } = props;
   return (
      <Card>
         <CardHeader
            title={
               <Typography component="p" color="textPrimary" variant="h5">
                  Mis productos y servicios
               </Typography>
            }
            disableTypography={true}
            avatar={
               <Avatar className={classes.avatar}>
                  <ShoppingCartIcon />
               </Avatar>
            }
            style={{paddingBottom: 0}}
         />
         <CardContent style={{paddingBottom: '16px'}}>
            <Grid container justify='center'>
               <Carousel
                  slidesToShow={{ xs: 1, sm: 2, md: 3 }}
                  slidesToScroll={1}
                  showIndicators={true}
                  autoplay={true}
                  autoplayInterval={4000}
                  infinite={true}
               >
                  {
                     data.map((item, index, arr) => (
                        <Grid key={index} container item className={classes.root} xs={11} style={{ justifySelf: 'center' }}>
                           <Grid
                              className={clsx(classes.container, classes['elevation1'])}
                              container
                              item
                              xs={12}
                              justify="center"
                              key={index}
                           >
                              <Grid item xs={12}>
                                 <Typography gutterBottom variant="h6">
                                    {item.producto.denominacion ? item.producto.denominacion : ''}
                                 </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                 <img
                                    className={classes.img}
                                    alt={item.title}
                                    src="https://www.dscont.pe/dsServices/images/dscontgolden.png"
                                 />
                              </Grid>

                              {item.producto.links !== undefined && item.producto.links.length !== 0 && (
                                 <Grid item xs={6} >
                                    {
                                       item.producto.links.map(link => (
                                          <Typography key={link.codigoLink} align='left' display='block' gutterBottom>
                                             <Link href={link.url}>
                                                {link.denominacion}
                                             </Link>
                                          </Typography>
                                       ))
                                    }
                                 </Grid>
                              )}
                           </Grid>
                        </Grid>
                     ))
                  }
               </Carousel>
            </Grid>
         </CardContent>
      </Card>
   );
}

Producto.propTypes = {
   loading: PropTypes.bool,
   data: PropTypes.array
};
